import { useEffect } from 'react'
import { NavInfoButton as Button } from 'ui-components'
import { Tools } from '~map-preview/App/Layout/Nav/Tools'
import { useMap, useReadmeNodes } from '~map-preview/states/map'
import { useMapNavStore } from '~map-preview/states/mapNav'

export function Info() {
  const map = useMap()
  const nodes = useReadmeNodes()
  const { sideBar, setSideBar, setOpenDrawer, setOpenMenu } = useMapNavStore()

  useEffect(() => {
    if (map && map.readme?.isOpenByDefault) {
      setSideBar(Tools.info.key)
      setOpenDrawer(true)
    }
  }, [map, setSideBar, setOpenDrawer])

  const handleClick = () => {
    setSideBar(Tools.info.key)
    setOpenDrawer(true)
    setOpenMenu(false)
  }

  if (!nodes) return null

  return (
    <Button
      selected={sideBar === Tools.info.key}
      onClick={handleClick}
    />
  )
}
